import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__connection_state } from '../../enums/ENUM__connection_state';
import { service_socketio_client } from '../../services/socketio_client_react/service_socketio_client';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { STATE__network } from './STATE__network';

export const remote_network_connect = createAsyncThunkSafe<void, void>('network/connect', async (): Promise<void> => {
  service_socketio_client.connect();
});

export function init_remote_network_connect(builder: ActionReducerMapBuilder<STATE__network>) {
  builder
    .addCase(remote_network_connect.pending, state => {
      state.state = ENUM__connection_state.CONNECTING;
    })
    .addCase(remote_network_connect.rejected, (state, action) => {
      state.state = ENUM__connection_state.DISCONNECTED;
    })
    .addCase(remote_network_connect.fulfilled, (state, action: PayloadAction) => {
      // The connection state is now managed by the Redux store
      // and updated through the socketService's event listeners
      // So we don't need to set it here
    });
}
